import React from "react";

const AllClientsList: React.FC = () => {
  return (
    <div id="clients-logo-bottom" className="py-5">
      <div className="container text-center">
        <div className="row">
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="CRED logo" src="/img/cred-logo.svg" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Hyundai logo" src="/img/hyundai-logo.svg" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Saina Play logo" src="/img/sainaplay-logo.png" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Josco logo" src="/img/josco-logo.svg" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Perch logo" src="/img/perch-logo.png" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Infosys logo" src="/img/infosys-logo.svg" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Client logo 7" src="/img/client-logo-7.png" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Client logo 8" src="/img/client-logo-8.png" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Client logo 9" src="/img/client-logo-9.png" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Client logo 10" src="/img/client-logo-10.png" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-4 mb-3">
            <div className="p-2 our-clients-logo">
              <img alt="Client logo 11" src="/img/client-logo-11.png" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllClientsList;
